import {initializeCalculatorStorage, initializePatientStorage} from '../stateHandler';
import {afterDomIsReady} from '../utils/whenLoaded';
import {getCheckedRadioByName} from '../utils/formFields';
import {assert} from '../utils/assert';
import {loadTemplate} from '../utils/loadTemplate';

export default () => afterDomIsReady(async () => {
	const templateEl = document.getElementById('pest-template') as HTMLTextAreaElement;
	assert(templateEl !== null);
	const getTemplate = await loadTemplate('./pest-template.html');
	const storage = initializeCalculatorStorage();

	const recount = () => {
		const currentState: {[key: string]: number|string} = {};
		let total = 0;

		for (let i = 1; i <= 5; i++) {
			const r = getCheckedRadioByName('q'+i).value;
			switch (r) {
				case '1':
					total++;
					currentState[i] = 1;
					break;
				case '0':
					currentState[i] = 0;
					break;
				default:
					throw new Error(`Option '${r}' is not implemented`);
			}
		}

		const totalAsString = total.toFixed(0);
		document.getElementById('pest-score')!.innerText = totalAsString;
		currentState['total'] = totalAsString;
		storage.update('pest', currentState);
	};

	// now
	recount();

	// and on every field change
	document.querySelectorAll('input[type=radio]').forEach(
		el => el.addEventListener('click', () => recount()));


	const resultEl = document.getElementById('pest-downloadForm');
	assert(resultEl !== null);
	resultEl.addEventListener('submit', () => {
		let template = getTemplate();

		const pacient = initializePatientStorage().get();
		template = template.replace('{titul}', pacient.degree || '');
		template = template.replace('{jmeno}', pacient.firstName || '');
		template = template.replace('{prijmeni}', pacient.lastName || '');
		template = template.replace('{datumVysetreni}', pacient.examinationDate || '');

		const state = storage.get('pest');
		for (let i = 1; i <= 5; i++) {
			template = template.replace(`{q${i}}`, state[i]);
		}
		template = template.replace('{celkem}', state.total);

		templateEl.value = template;
	});
});
